import { render, staticRenderFns } from "./PackingSlipPrintTemplate.vue?vue&type=template&id=dd00853a&scoped=true"
import script from "./PackingSlipPrintTemplate.vue?vue&type=script&lang=js"
export * from "./PackingSlipPrintTemplate.vue?vue&type=script&lang=js"
import style0 from "./PackingSlipPrintTemplate.vue?vue&type=style&index=0&id=dd00853a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd00853a",
  null
  
)

export default component.exports